module.exports = {"id":"160043","name":"Anyelo Candelo","rating":"72","photo":"./data/images/photos/2/160043.png","club":{"name":"CD Everton","logo":"./data/images/clubs/CDEverton.png"},"positions":["DD","DG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnyeloCandelo0.json
// module id = 454
// module chunks = 0